export default __webpack_public_path__ + "static/media/investors.9f5cf0b6.mp3";